import React, { useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import ChatReportList from "../../../components/reports/chats/ChatReportList";
import ChatRoom from "../../../components/conversations/ChatRoom";
import ChatHistoryReport from "../chatHistoryReport";

const ChatRoute = () => {
  const [isChatroomId, setChatRoomId] = useState<number>(0);
  return (
    <Routes>
      <Route
        path="/conversationHistory-report"
        element={
          <>
            <ChatHistoryReport setChatRoomId={setChatRoomId} />
          </>
        }
      />
      <Route
        path="/conversationHistory-report/:chatroomId"
        element={
          <div className="d-flex flex-column flex-lg-row mt-4 mx-4">
            <ChatRoom
              type={"Chat-Report"}
              chatRoomID={isChatroomId}
              setSearchParams={() => {}} // Default empty function
              setIsData2={() => {}} // Default empty function
              setIsData3={() => {}}
              searchParams={() => {}}
              handleOpenChat={() => {}}
              handleCloseChat={() => {}}
              handleMinimizeChat={() => {}}
              chatPanels={() => {}}
              disabledIndexes={() => {}}
            />
          </div>
        }
      />

      <Route index element={<Navigate to="/conversation/conversationHistory-report" />} />
    </Routes>
  );
};

export default ChatRoute;
